import moment from 'moment';

export const SCALE_ORDER = ['hour', 'quarterDay', 'halfDay', 'day', 'week', 'month', 'quarter', 'year'];

const fmt = (pattern) => (date) => moment(date).format(pattern);

const currentPeriod =
  (unit, step = 1) =>
  (date) =>
    moment().isBetween(date, moment(date).add(step, unit), undefined, '[)') ? 'gantt-current-period' : '';

export const highlightWeekends = (date, unit) =>
  (unit === 'day' || unit === 'hour') && (date.getDay() === 0 || date.getDay() === 6) ? 'wx-weekend' : '';

export const SCALES = {
  hour: {
    lengthUnit: 'minute', // точность ленты
    stepUnit: 'hour', // шаг правки
    cellWidth: 40,
    scales: [
      { unit: 'day', step: 1, format: fmt('D MMM, dd') },
      { unit: 'hour', step: 1, format: fmt('HH'), css: currentPeriod('hour') },
    ],
  },
  quarterDay: {
    lengthUnit: 'minute',
    stepUnit: 'hour',
    cellWidth: 40,
    scales: [
      { unit: 'day', step: 1, format: fmt('D MMM, dd') },
      { unit: 'hour', step: 6, format: fmt('HH'), css: currentPeriod('hour', 6) },
    ],
  },
  halfDay: {
    lengthUnit: 'minute',
    stepUnit: 'hour',
    cellWidth: 60,
    scales: [
      { unit: 'day', step: 1, format: fmt('D MMM, dd') },
      { unit: 'hour', step: 12, format: fmt('HH'), css: currentPeriod('hour', 12) },
    ],
  },
  day: {
    lengthUnit: 'hour',
    stepUnit: 'day',
    cellWidth: 50,
    scales: [
      { unit: 'month', step: 1, format: fmt('MMMM YYYY') },
      { unit: 'day', step: 1, format: fmt('D dd'), css: currentPeriod('day') },
    ],
  },
  week: {
    lengthUnit: 'hour',
    stepUnit: 'day',
    cellWidth: 100,
    scales: [
      { unit: 'month', step: 1, format: fmt('MMMM YYYY') },
      { unit: 'week', step: 1, format: fmt('DD.MM'), css: currentPeriod('week') },
    ],
  },
  month: {
    lengthUnit: 'day',
    stepUnit: 'day',
    cellWidth: 120,
    scales: [
      { unit: 'year', step: 1, format: fmt('YYYY') },
      { unit: 'month', step: 1, format: fmt('MMM'), css: currentPeriod('month') },
    ],
  },
  quarter: {
    lengthUnit: 'day',
    stepUnit: 'day',
    cellWidth: 130,
    scales: [
      { unit: 'year', step: 1, format: fmt('YYYY') },
      { unit: 'quarter', step: 1, format: fmt('Q [кв.]'), css: currentPeriod('quarter') },
    ],
  },
  year: {
    lengthUnit: 'day',
    stepUnit: 'day',
    cellWidth: 150,
    scales: [{ unit: 'year', step: 1, format: fmt('YYYY'), css: currentPeriod('year') }],
  },
};

// SVAR нумерует уровни зума от крупного к мелкому, у нас наоборот
const ZOOM_SCALE_ORDER = [...SCALE_ORDER].reverse();

export const ZOOM_LEVELS = ZOOM_SCALE_ORDER.map((key) => {
  const { cellWidth, scales } = SCALES[key];
  return { minCellWidth: cellWidth, maxCellWidth: cellWidth, scales };
});

export const scaleToZoomLevel = (scale) => ZOOM_SCALE_ORDER.indexOf(scale);

// Сколько единиц ленты в одном шаге правки: минут в часе, часов в сутках, суток в сутках.
// Этим числом сдвиг, пришедший от библиотеки, переводится в шаги масштаба и обратно
export const unitsPerStep = ({ lengthUnit, stepUnit }) => moment.duration(1, stepUnit).as(lengthUnit);

// Масштаб на шаг в сторону зума: dir = 1 — приближение, -1 — отдаление.
// Зум мы считаем сами, потому что библиотека на этом же событии переписывает единицу
// длины — и переписывает мимо, минуты она при таком пересчёте не знает
export const zoomedScale = (scale, dir) => SCALE_ORDER[SCALE_ORDER.indexOf(scale) - dir];
